import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSessionCookie } from '../../../utils/cookies';
import { useLoginForm } from './use-login-form';

const useLoginLogics = () => {

    const navigate = useNavigate();

    const { formik, isPending } = useLoginForm()
    useEffect(() => {
        if (getSessionCookie("accessToken")) {
            navigate("/dashboard");
        }
    }, []);


    return {
        isLoggingIn: isPending,
        formik
    }
}

export default useLoginLogics